
import router, {constantRoutes,asyncBaseRoute,asyncRoutes} from '@/router'
import axios from '@/libs/http'
import store from '@/store/index'
import map from '@/components/map'

const user = store.state.user;
const menu = store.state.menu;


export default {
    getIsConstantRoutes(currentPath){
        let is = false
        for(let i = 0;i<constantRoutes.length;i++){
            if(constantRoutes[i].path === currentPath){
                is = true
                break
            }
        }
        return is
    },
	validate(to, from, next) {
        if (to.path === '/login') {
            if (user.isLogin) {
                next({path: '/index'})
            } else {
                next()
            }
        } else {
            if (user.isLogin) {
                if (menu.list.length) {
                    next()
                } else {
                    this.getMenu(to, from, next)
                }
            } else if(this.getIsConstantRoutes(to.path)){
               next()
            }else{
                next({path: '/login'})
            }
        }
	},
	getMenu(to,from,next) {
		axios.post('/portal/menu/getMenu',null).then(data => {
			if(data.status==axios.HTTP_S){
				store.commit('setList',data.result.List);
				this.getRouter(to,from,next);
			}
		});
	},
    getRouter(to,from,next){
		axios.post('/portal/web/router',null).then(async data => {
			if(data.status==axios.HTTP_S){
				const routerD = map.filterAsyncRouter(data.result)
                store.commit('setRouterList',routerD[1].children);
                asyncRoutes[0].children = asyncBaseRoute.concat(routerD[1])
				router.addRoutes(asyncRoutes);
				await this.isProduct()
				next({ path:to.path,replace:true })
			}
		});
	},
	isProduct(){
		axios.post('/gyl/ec_info/checkOrgProdConnAndAgreementAndPay',null).then(data => {
			if(data.status==axios.HTTP_S){
				store.commit('openObj',data.result);
			}else{
				//是否开通产品openFlag、是否签署e诺产品使用协议agreementFlag、是否签署付款承诺函payFlag等标识（若是新更新的协议，则需要重新签署）
				store.commit('openObj',{openFlag:false,agreementFlag:false,payFlag:false});
			}
		});
	}
};



// WEBPACK FOOTER //
// ./src/router/auth.js